import React from 'react';
import { KatBox } from '@amzn/katal-react';
import * as constants from '../appConstants';
import initialMetricsPublisher from '../metrics';

import './App.scss';

export class Welcome extends React.Component {

    render() {
        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("WelcomePage");
        actionMetricsPublisher.publishCounterMonitor('visits', 1);

        return (
           <KatBox>
               Scratchpad is a tool to help developers send basic requests to the Amazon Pay API. Follow the steps below and you can have a working request with sample code in minutes.
               <br/>
               <br/>
               <h3>Getting Started</h3>
               You need to perform the following steps before beginning your integration:
               <ol>
                   <li>Register for Amazon Pay. Sign up for an Amazon Pay merchant account on the Amazon Pay website.</li>
                   <li>Create a Sandbox test buyer account. For details, see Amazon Pay Sandbox accounts. After creating a Sandbox buyer account, return to this page.</li>
                   <li>After you have your Merchant ID and Credentials (public/private key), enter those details in the Authentication section, and choose an API operation from the left panel.</li>
                   <li>Type the request parameters and choose Run request.</li>
                   <li>Under the Response section, locate the returned response.</li>
               </ol>
               You can also click on "Button Code" in the left navigation panel to access a button generator tool.
               <br/><br/>

               Change the Scratchpad region:
                   &nbsp;<a href={constants.HTTPS+constants.PAY_API+constants.US_HOST+constants.SCRATCHPAD_URI}>US</a>,
                   &nbsp;<a href={constants.HTTPS+constants.PAY_API+constants.EU_HOST+constants.SCRATCHPAD_URI}>Europe</a>,
                   &nbsp;<a href={constants.HTTPS+constants.PAY_API+constants.JP_HOST+constants.SCRATCHPAD_URI}>Japan</a>
               <br/><br/>

               <h3>Additional Resources</h3>
               <ul>
                   <li>Scratchpad How-to Guide (
                           <a href={constants.LINK_SCRATCHPAD_HELP} target="blank" rel="noopener noreferrer">English</a>,&nbsp;
                           <a href={constants.LINK_SCRATCHPAD_HELP_JP} target="blank" rel="noopener noreferrer">JP</a>
                       )<br/>Get started with the Amazon Pay Scratchpad.
                   </li>
                   <li><a href={constants.LINK_GET_SECURITY_CREDENTIALS} target="blank" rel="noopener noreferrer">Get Security Credentials</a><br/>See instructions for retrieving your public/private Key pair.</li>
                   <li><a href={constants.LINK_API_HELP} target="blank" rel="noopener noreferrer">API Documentation</a><br/>See the complete API documentation to learn more.</li>
               </ul>
           </KatBox>
        );
    }
}

export default Welcome;
